import { render } from "./warn1.vue?vue&type=template&id=7587adea&scoped=true"
import script from "./warn1.vue?vue&type=script&lang=js"
export * from "./warn1.vue?vue&type=script&lang=js"

import "./warn1.vue?vue&type=style&index=0&id=7587adea&lang=scss&scoped=true"
import "./warn1.vue?vue&type=style&index=1&id=7587adea&lang=scss&scoped=true"
import "./warn1.vue?vue&type=style&index=2&id=7587adea&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7587adea"]])

export default __exports__